// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import store from './store/index.js'
import App from './App'
import router from './router/index'
import {TokenService} from './services/account/storage.service'
import ApiService from './services/web/api.service'

import BootstrapVue from 'bootstrap-vue'
import vueDebounce from 'vue-debounce'
import JsonViewer from 'vue-json-viewer'

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import 'vue-select/dist/vue-select.css';

Vue.use(BootstrapVue)
Vue.use(vueDebounce, {defaultTime: '700ms', listenTo: ['paste','input']})
Vue.use(JsonViewer)

import DateFormat from 'dateformat'

import SelectCompanyModal from '@/views/components/SelectCompanyModal.vue'
import ButtonAdd from '@/views/components/buttons/ButtonAdd.vue'
import ButtonMap from '@/views/components/buttons/ButtonMap.vue'
import ButtonFullScreen from '@/views/components/buttons/ButtonFullScreen.vue'
import ButtonAddFile from '@/views/components/buttons/ButtonAddFile.vue'
import ButtonAddFile2 from '@/views/components/buttons/ButtonAddFile2.vue'
import ButtonAddFileByGroup from '@/views/components/buttons/ButtonAddFileByGroup.vue'
import ButtonAddFiles from '@/views/components/buttons/ButtonAddFiles.vue'
import ButtonAdditionalInfo from '@/views/components/buttons/ButtonAdditionalInfo.vue'
import ButtonBack from '@/views/components/buttons/ButtonBack.vue'
import ButtonCheck from '@/views/components/buttons/ButtonCheck.vue'
import ButtonCancel from '@/views/components/buttons/ButtonCancel.vue'
import ButtonClock from '@/views/components/buttons/ButtonClock.vue'
import ButtonCorrection from '@/views/components/buttons/ButtonCorrection.vue'
import ButtonClone from '@/views/components/buttons/ButtonClone.vue'
import ButtonDelete from '@/views/components/buttons/ButtonDelete.vue'
import ButtonEdit from '@/views/components/buttons/ButtonEdit.vue'
import ButtonEditSave from '@/views/components/buttons/ButtonEditSave.vue'
import ButtonExcel from '@/views/components/buttons/ButtonExcel.vue'
import ButtonExport from '@/views/components/buttons/ButtonExport.vue'
import ButtonInfo from '@/views/components/buttons/ButtonInfo.vue'
import ButtonLink from '@/views/components/buttons/ButtonLink.vue'
import ButtonPrint from '@/views/components/buttons/ButtonPrint.vue'
import ButtonRefresh from '@/views/components/buttons/ButtonRefresh.vue'
import ButtonReportStatements from '@/views/components/buttons/ButtonReportStatements.vue'
import ButtonUnlink from '@/views/components/buttons/ButtonUnlink.vue'
import ButtonsetPassword from '@/views/components/buttons/ButtonSetPassword.vue'
import ButtonSave from '@/views/components/buttons/ButtonSave.vue'
import ButtonSettings from '@/views/components/buttons/ButtonSettings.vue'
import ButtonTrash from '@/views/components/buttons/ButtonTrash.vue'
import ButtonUndo from '@/views/components/buttons/ButtonUndo.vue'
import ButtonUpload from '@/views/components/buttons/ButtonUpload.vue'
import ButtonValidate from '@/views/components/buttons/ButtonValidate.vue'

import InputSearchSelect from '@/views/components/inputs/InputSearchSelect.vue'
import InputSearchSelectGroup from '@/views/components/inputs/InputSearchSelectGroup.vue'

import PageTable from '@/views/components/tables/PageTable.vue'
import ListTable from '@/views/components/tables/ListTable.vue'
import BaseTableCard from '@/views/components/cards/BaseTableCard.vue'
import BaseTableListCard from '@/views/components/cards/BaseTableListCard.vue'
import BaseTableCardNoHeader from '@/views/components/cards/BaseTableCardNoHeader.vue'
import BaseTableTabPageCard from '@/views/components/cards/BaseTableTabPageCard.vue'

import Dropdown from 'vue-simple-search-dropdown'

import 'bootstrap-icons/font/bootstrap-icons.css';

Vue.component('SelectCompanyModal', SelectCompanyModal)
Vue.component('ButtonAdd', ButtonAdd)
Vue.component('ButtonMap', ButtonMap)
Vue.component('ButtonFullScreen', ButtonFullScreen)
Vue.component('ButtonAddFile', ButtonAddFile)
Vue.component('ButtonAddFile2', ButtonAddFile2)
Vue.component('ButtonAddFiles', ButtonAddFiles)
Vue.component('ButtonAddFileByGroup', ButtonAddFileByGroup)
Vue.component('ButtonAdditionalInfo', ButtonAdditionalInfo)
Vue.component('ButtonBack', ButtonBack)
Vue.component('ButtonClock', ButtonClock)
Vue.component('ButtonCancel', ButtonCancel)
Vue.component('ButtonCorrection', ButtonCorrection)
Vue.component('ButtonClone', ButtonClone)
Vue.component('ButtonCheck', ButtonCheck)
Vue.component('ButtonDelete', ButtonDelete)
Vue.component('ButtonEdit', ButtonEdit)
Vue.component('ButtonEditSave', ButtonEditSave)
Vue.component('ButtonExcel', ButtonExcel)
Vue.component('ButtonExport', ButtonExport)
Vue.component('ButtonInfo', ButtonInfo)
Vue.component('ButtonLink', ButtonLink)
Vue.component('ButtonPrint', ButtonPrint)
Vue.component('ButtonRefresh', ButtonRefresh)
Vue.component('ButtonReportStatements', ButtonReportStatements)
Vue.component('ButtonUnlink', ButtonUnlink)
Vue.component('ButtonSetPassword', ButtonsetPassword)
Vue.component('ButtonSave', ButtonSave)
Vue.component('ButtonSettings', ButtonSettings)
Vue.component('ButtonTrash', ButtonTrash)
Vue.component('ButtonUndo', ButtonUndo)
Vue.component('ButtonUpload', ButtonUpload)
Vue.component('ButtonValidate', ButtonValidate)

Vue.component('InputSearchSelect', InputSearchSelect)
Vue.component('InputSearchSelectGroup', InputSearchSelectGroup)

Vue.component('PageTable', PageTable)
Vue.component('ListTable', ListTable)
Vue.component('BaseTableCard', BaseTableCard)
Vue.component('BaseTableListCard', BaseTableListCard)
Vue.component('BaseTableCardNoHeader', BaseTableCardNoHeader)
Vue.component('BaseTableTabPageCard', BaseTableTabPageCard)


Vue.component('Dropdown', Dropdown)

Vue.component("fancybox", {
  template: `
    <a class="js-fancybox"><slot /></a>
  `,
  mounted() {
    $(".js-fancybox").fancybox({
      infobar: false,
      buttons: [
        "zoom",
        "share",
        "slideShow",
        "fullScreen",
        "download",
        "thumbs",
        "close"
      ]
    });
  }
});

import excel from "vue-excel-export";
Vue.use(excel);

/*Vue.directive("uppercase", {
  update: function (el) {
      el.value = el.value.toUpperCase()
      console.log(el.value)
  }
})*/

Vue.mixin({
  methods:  {
    dateFormat(date, format) {
      if (!format) {
        format = 'yyyy-mm-dd HH:MM:ss'
      }

      return DateFormat(date, format)
    },

    mapInterpolation(x, inMin, inMax, outMin, outMax) {
      return (x - inMin) * (outMax - outMin) / (inMax - inMin) + outMin
    },

    showDangerMessage(error) {
      let message = ``
      let code = '---'
      let title = ''
      if (error.response) {
        // Request made and server responded
        message += `${error.response.data} \r\n`
        code = error.response.status
      } else if (error.request) {
        // The request was made but no response was received
        message += `${error.request} \r\n`
        code = error.request.status
      } else {
        // Something happened in setting up the request that triggered an Error
        message += `${error.message} \r\n`
      }

      if (error.response) {
        // Request made and server responded
        console.log('1', error.response.data);
        console.log('2',error.response.status);
        console.log('3',error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }

      if (code == 400) {
        title = `Неверные параметры!`
      }

      if (code == 404) {
        title = `Сервер не может найти данные! \r\n`
      }

      return this.$bvModal.msgBoxOk(`${message}`, {
        title: `${code} ${title}`,
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'danger',
        footerClass: 'p-2',
        centered: true
      })
    },
    
    showErrorMessage(msg) {
      return this.$bvModal.msgBoxOk(msg, {
        title: 'Внимание',
        size: 'lg',
        buttonSize: 'sm',
        okVariant: 'danger',
        footerClass: 'p-2',
        centered: true
      })
    },

    showInfoMessage(msg) {
      return this.$bvModal.msgBoxOk(msg, {
        title: 'Внимание',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'info',
        footerClass: 'p-2',
        centered: true
      })
    },

    showConfirmMessage(msg) {
      return new Promise((resolve, reject) => {
        this.$bvModal.msgBoxConfirm(msg, {
          title: 'Внимание',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Да',
          cancelTitle: 'Нет',
          footerClass: 'p-2',
          centered: true
        }).then(res => {
          if (res) {
            resolve()
          }
        }).catch(res => {
          reject(res)
        })
      });
    },

    reportSetVariables(report, setUserSelect) {
      if (setUserSelect) {
        if (report.dictionary.variables.getByName('IdCompanySelect')) {
          report.dictionary.variables.getByName('IdCompanySelect').valueObject = this.idCompany
        }
        if (report.dictionary.variables.getByName('IdUserSelect')) {
          report.dictionary.variables.getByName('IdUserSelect').valueObject = this.idUser
        }
      }
      if (report.dictionary.variables.getByName('IdCompany')) {
        report.dictionary.variables.getByName('IdCompany').valueObject = this.idCompany
      }
      if (report.dictionary.variables.getByName('IdUser')) {
        report.dictionary.variables.getByName('IdUser').valueObject = this.idUser
      }
      if (report.dictionary.variables.getByName('IdRole')) {
        report.dictionary.variables.getByName('IdRole').valueObject = this.idRole
      }
      if (report.dictionary.variables.getByName('CompanyTypePublicCode')) {
        report.dictionary.variables.getByName('CompanyTypePublicCode').valueObject = this.companyTypePublicCode
      }
      if (report.dictionary.variables.getByName('Today')) {
        report.dictionary.variables.getByName('Today').valueObject = DateFormat(Date.now(), 'yyyy-mm-dd')        
      }
    },

    getIconClassByReportType(reportType) {
      //console.log(reportType)
      switch(reportType) {
        case 'excell':
          return ' fa fa-file-excel-o fa-lg '

        case 'word':
          return ' fa fa-file-word-o fa-lg '

        case 'pdf': 
          return ' fa fa-file-pdf-o fa-lg '

        default: 
          return ' fa fa-photo fa-lg '
      }
    },
  }
})

fetch(process.env.BASE_URL + "config.json")
  .then((response) => {
    console.log('Loaded config.json')
    console.log(response)
    return response.json();
  })
  .then((config) => {
    console.log('Parsed config.json')
    console.log(config)
    return ApiService.initAsync(config.rootApi)
  })
  /*.then(() => {
    console.log('Api Initialized...')
    return store.dispatch('api/loadAllApiAsync')
  })*/
  .then(() => {
    //console.log('Loaded All Api')

    new Vue({
      el: '#app',
      router,
      store,
      template: '<App/>',
      components: {
        App
      },
      mounted() {
        store.dispatch('setTokenService', TokenService);
      }
    })
  })  
  .catch(() => {
    console.log('--- start local ---')    
    //ApiService.init('https://82.200.139.50:5500')   
    //ApiService.init('http://localhost:64175')
    ApiService.init('https://localhost:44387')
    //ApiService.init('https://asdsp-api.aquameter.kz/')
    new Vue({
      el: '#app',
      router,
      store,
      template: '<App/>',
      components: {
        App, ButtonDelete
      },
      mounted() {
        store.dispatch('setTokenService', TokenService);
      }
    })
  })  




//ApiService.init('http://localhost:64175')
//ApiService.init('http://aquameter.kz:5000/')
//ApiService.init('https://192.168.64.3:5000')

// If token exists set header
let token = TokenService.getToken()
if (token) {
  ApiService.setHeader()  
}

StiOptions.WebServer.encryptData = false
//StiOptions.WebServer.url = "https://localhost:44311/Handler.ashx"
StiOptions.WebServer.url = "https://asdsp-adapter.aquameter.kz/Handler.ashx"

Stimulsoft.Base.StiLicense.key = "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHnfi/c79Cku1bRBmXwbfoyeAuqnTtfFOP3JPe/8Dn0KKKxJgD" + 
"smJwNWDDe6TPRLV1i+OzfWV9LAQQBFiUGB05B07oJkAdZnegCfboJ7//AUrOc7O5eNxOOCVyJLws1XYp3PEBhYjCaA" + 
"EzPV9i+VEFrNBmoyWXBwMldlMj/dxcOI3elTtTKOi2fR/7QleJzpg/osPq0wsi9XwWEbWRF70ua7jJFPDp2d/HhqOy" + 
"5z/GIpS4hH/Ao0gzdbDKfY9KE+LOGcbRccIF5NHtjYsYHUMX5AgVvFHqGQ+3vgthSqe6VN+RUTnlIw8L/8xTZN2zQV" + 
"tOv2x3p0D0cCEc7clQ+EX9DvNE6xFTZGO8lNIYdFA2latWv2hhGDnXtJj9EY2M38DmFDNrG3uoxobvJ6p76pVSr+Tg" + 
"iWjYS5Aqb4s65gqfDY8L6K2ov4BKFUDK1sPcphWreunwZeSiMYtIDhQxO4VxSrXIEmWPD8U//IuyxAVxVKao8/ljqP" + 
"FxnUJebX34vluoZOUphIkoAG3TRX5jrD6txsnZVTLWVPiQgljD4Yjj8kGg==";
